module.exports = __webpack_public_path__ + "static/img/introduction-welcome-quote.70855af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-welcome-quote.jpg
// module id = a2l8
// module chunks = 0